import { createContext, useContext, useEffect, useState } from "react";

const dict = {
  it: {
    nav: { showcase: "Vetrina", directory: "Strutture", network: "Rete", pricing: "Tariffe", login: "Accedi", signup: "Iscrivi struttura", dashboard: "Dashboard", logout: "Esci", book: "Prenota", host_area: "Gestisco una struttura" },
    landing: {
      eyebrow: "Piattaforma per strutture ricettive",
      title1: "Ospitalità italiana,",
      title2: "in rete.",
      subtitle: "Promuovi la tua struttura, sincronizza le OTA, scambia camere con partner fidati. Una casa digitale per B&B, agriturismi e hotel.",
      cta_primary: "Inizia gratis",
      cta_secondary: "Guarda le vetrine",
      f1_title: "Vetrina bilingue",
      f1_body: "Una pagina pubblica IT/EN che racconta la tua struttura. Foto, camere, prenotazione diretta con Stripe.",
      f2_title: "Rete tra strutture",
      f2_body: "Sei overbooked? Gira il cliente a un partner. Marketplace nazionale + gruppi chiusi locali.",
      f3_title: "Richieste di gruppo",
      f3_body: "Pubblica una richiesta di gruppo numeroso, le strutture vicine rispondono. Colazione centralizzata inclusa.",
      f4_title: "Calendario unico",
      f4_body: "Prenotazioni dirette, camere in rete, OTA sincronizzate via iCal (in arrivo). Zero overbooking.",
      showcase_title: "Strutture in vetrina",
      showcase_sub: "Alcune delle case che si raccontano su HospitalityHub.",
      how_title: "Come funziona",
      how_1: "Iscrivi la tua struttura",
      how_1b: "Registrazione in 60 secondi. Verifica automatica per l'MVP.",
      how_2: "Configura la vetrina IT/EN",
      how_2b: "Testi bilingua, foto, servizi, camere. Pubblica quando sei pronta.",
      how_3: "Entra nella rete",
      how_3b: "Offri camere last-minute, rispondi a richieste di gruppo, ricevi pagamenti.",
      final_title: "La casa digitale delle strutture ricettive",
      final_body: "Un'unica piattaforma per gestire vetrina, rete e prenotazioni.",
    },
    auth: {
      login: "Accedi",
      register: "Iscrivi la tua struttura",
      email: "Email",
      password: "Password",
      structure: "Nome struttura",
      cin_label: "Codice CIN",
      cin_help: "Codice Identificativo Nazionale MITUR — obbligatorio per legge (DL 145/2023). Formato nazionale: IT + 15 caratteri (17 totali). Alcune regioni come Sicilia possono usare formati più lunghi (fino a 22 caratteri). Richiedilo su bdsr.ministeroturismo.gov.it",
      submit_login: "Entra",
      submit_register: "Crea account",
      switch_to_register: "Non hai un account? Iscrivi la struttura",
      switch_to_login: "Hai già un account? Accedi",
      forgot: "Password dimenticata?",
      demo_hint: "Demo: demo@hospitalityhub.it / demo1234",
    },
    dash: {
      welcome: "Benvenuta,", overview: "Panoramica", property: "Struttura",
      rooms: "Camere", bookings: "Prenotazioni", marketplace: "Rete",
      groups: "Richieste gruppo", reviews: "Recensioni",
      ical: "OTA Sync", swaps: "Scambi", breakfast: "Colazione",
      total_bookings: "Prenotazioni totali", revenue: "Ricavi",
      open_offers: "Offerte aperte", published: "Pubblicata",
      not_published: "Non pubblicata",
      publish: "Pubblica vetrina", unpublish: "Nascondi vetrina",
      view_showcase: "Vedi vetrina pubblica",
      copy_link: "Copia link", copied: "Copiato!",
      save: "Salva modifiche", saved: "Salvato",
      name: "Nome", city: "Città", region: "Regione", address: "Indirizzo",
      phone: "Telefono", desc_it: "Descrizione (IT)", desc_en: "Descrizione (EN)",
      amenities: "Servizi (separati da virgola)",
      hero_image: "Foto principale",
      photos: "Galleria foto",
      property_type: "Tipo struttura",
      add_room: "Aggiungi camera", room_name: "Nome camera",
      price_night: "Prezzo/notte (€)", capacity: "Capacità",
      photo_url: "URL foto",
      publish_offer: "Metti in rete",
      no_bookings: "Nessuna prenotazione ancora",
      no_rooms: "Nessuna camera. Aggiungine una per iniziare.",
      offer_from: "Da", offer_to: "A",
      post_group_req: "Pubblica richiesta gruppo",
      title: "Titolo", guests: "Ospiti", budget: "Budget/notte (€)",
      notes_it: "Note (IT)", notes_en: "Note (EN)",
      respond: "Rispondi", rooms_offered: "Camere offerte",
      message: "Messaggio", send: "Invia risposta",
      responses: "risposte",
      total: "Totale",
      night: "notte", nights: "notti",
      upload_photo: "Carica foto",
      uploading: "Caricamento...",
      drop_here: "Trascina o clicca per caricare",
      remove: "Rimuovi",
      // iCal
      ical_title: "Sincronizza OTA via iCal",
      ical_sub: "Importa disponibilità e prenotazioni da Booking, Airbnb, Expedia, Vrbo.",
      ical_url: "URL iCal",
      ical_source: "Piattaforma", ical_import: "Importa",
      ical_last_sync: "Ultima sync", ical_events: "Eventi importati",
      calendar_unified: "Calendario unificato",
      // Swaps
      swap_forward: "Inoltra a partner",
      swap_title: "Scambio camera",
      partner_property: "Struttura partner",
      partner_room: "Camera partner",
      commission_10: "Commissione 10% verrà trattenuta",
      swap_notes: "Note per il partner",
      swap_send: "Proponi scambio",
      no_swaps: "Nessuno scambio ancora",
      // Breakfast
      breakfast_title: "Colazione centralizzata",
      breakfast_sub: "Offri o prenota colazioni per i tuoi ospiti in rete.",
      add_breakfast_slot: "Nuovo turno colazione",
      slot_date: "Data", slot_time: "Ora",
      slot_max: "Coperti massimi",
      slot_price: "Prezzo/coperto (€)",
      book_covers: "Prenota coperti",
      covers: "coperti",
      book_slot: "Prenota", available: "disponibili",
      your_breakfast_bookings: "Le tue prenotazioni colazione",
      role: "Ruolo", date: "Data", amount: "Importo",
      source: "Origine", event_title: "Titolo", start: "Inizio", end: "Fine",
      no_events: "Nessun evento — importa un iCal o ricevi una prenotazione.",
      welcome_back: "Bentornata",
      toast_uploaded: "Caricato", toast_upload_failed: "Caricamento fallito",
      toast_error: "Errore", toast_swap_sent: "Scambio proposto · ospite avvisato",
      toast_slot_added: "Turno aggiunto", toast_slot_booked: "Prenotato",
      toast_offer_posted: "Offerta pubblicata", toast_gr_posted: "Richiesta pubblicata",
      toast_response_sent: "Risposta inviata", toast_imported: "Importati {n} eventi",
      select_room: "Seleziona camera", select_partner: "Seleziona partner",
      select_booking: "Seleziona prenotazione", no_paid_bookings: "Nessuna prenotazione pagata",
      per_cover: "per coperto",
      outgoing: "in uscita", incoming: "in arrivo",
      from_label: "Da:", to_label: "A:",
      commission_10pct: "Commissione (10%)",
      // Analytics
      analytics: "Analytics",
      revenue_monthly: "Ricavi mensili",
      direct_bookings: "Prenotazioni dirette",
      swap_commissions: "Commissioni scambi",
      breakfast_income: "Ricavi colazione",
      no_analytics: "Ancora nessun dato — inizia a ricevere prenotazioni.",
      // Connect
      stripe_connect: "Payouts automatici",
      connect_start: "Attiva Stripe Connect",
      connect_continue: "Completa onboarding",
      connect_done: "Payouts attivi",
      connect_pending: "Onboarding in corso",
      connect_hint: "Ricevi automaticamente le prenotazioni dirette al netto della commissione HospitalityHub (8% Base · 6% Pro · 5% Enterprise). Costi Stripe gestione pagamenti a carico del conto collegato.",
      // Group accept
      accept_split: "Accetta e ripartisci",
      select_partners: "Seleziona partner",
      allocated_rooms: "Camere assegnate",
      allocation_confirmed: "Ripartizione confermata",
      // Push
      push_title: "Notifiche browser",
      push_hint: "Ricevi un avviso sul dispositivo anche quando la scheda è chiusa.",
      push_enable: "Attiva notifiche", push_disable: "Disattiva",
      push_on: "Attive", push_off: "Spente", push_denied: "Bloccate dal browser",
      // Instagram
      instagram: "Instagram",
      ig_handle: "Handle Instagram (@)",
      ig_posts: "Post recenti",
      ig_add: "Aggiungi post",
      ig_image: "URL immagine",
      ig_caption: "Didascalia",
      ig_link: "Link post",
      // Verification
      verification: "Verifica",
      verify_title: "Verifica struttura",
      verify_hint: "Le strutture verificate compaiono con il bollino ✓ sul marketplace e sulla vetrina.",
      verified: "Verificata",
      pending_verify: "In attesa",
      not_verified: "Non verificata",
      submit_verify: "Richiedi verifica",
      vat_number: "Partita IVA (11 cifre)",
      business_name: "Ragione sociale",
      municipality: "Comune",
      declaration: "Dichiaro sotto la mia responsabilità che questi dati sono corretti",
      // Admin
      admin: "Amministrazione",
      admin_pending: "Richieste in attesa",
      approve: "Approva", reject: "Respingi",
      admin_note: "Nota interna",
      // AI copy
      ai_copy: "Genera con AI",
      ai_copy_title: "Genera vetrina con AI",
      ai_copy_hint: "Inserisci qualche parola chiave — l'AI creerà descrizione IT/EN e servizi.",
      ai_keywords: "Parole chiave (separate da virgola)",
      ai_tone: "Tono",
      ai_generate: "Genera",
      ai_apply: "Applica alla vetrina",
      // Loyalty
      promo_code: "Codice sconto",
      promo_apply: "Applica",
      promo_valid: "Codice valido",
      promo_saved: "Risparmi",
      // Trade
      trade_nav: "Trade B2B",
      trade_title: "Vendita B2B per tour operator e agenzie",
      trade_sub: "Compra blocchi di camere direttamente dalle strutture italiane a tariffe riservate.",
      trade_offers: "Offerte trade",
      trade_login: "Accedi trade", trade_register: "Registra agenzia",
      trade_company: "Nome agenzia / tour operator",
      trade_vat: "Partita IVA",
      trade_country: "Paese",
      trade_publish: "Pubblica offerta trade",
      trade_new_offer: "Nuova offerta trade",
      trade_rooms_available: "Camere disponibili",
      trade_price_per_night: "Prezzo/camera/notte (€)",
      trade_min_nights: "Notti minime",
      trade_buy: "Compra ora",
      trade_orders_mine: "Le mie prenotazioni",
      trade_sold: "vendute",
      trade_tab: "Trade",
      channels_tab: "Canali OTA",
    },
    vetrina: {
      book: "Prenota", from: "da", per_night: "/ notte",
      rooms: "Camere", reviews: "Recensioni", contact: "Contatti",
      leave_review: "Lascia una recensione",
      guest_name: "Il tuo nome", rating: "Valutazione",
      comment: "Il tuo commento", submit: "Invia recensione",
      services: "Servizi", check_in: "Check-in", check_out: "Check-out",
      guest_email: "La tua email", confirm_book: "Conferma e paga",
      total_price: "Totale", processing: "Elaborazione...",
      book_this_room: "Prenota questa camera",
      promo_code: "Codice sconto", promo_apply: "Applica",
      promo_valid: "Codice valido", promo_saved: "Risparmi",
    },
    guest: {
      my_bookings: "Le mie prenotazioni",
      my_maps: "Le mie mappe",
      travellers_area: "Area viaggiatori",
      have_account: "Hai già un account?",
      login: "Accedi",
      signup: "Registrati",
    },
    pay: {
      success: "Prenotazione confermata",
      success_body: "Riceverai una email di conferma. Grazie!",
      cancel: "Pagamento annullato",
      cancel_body: "Nessun addebito è stato effettuato.",
      back_home: "Torna alla home",
      checking: "Verifica pagamento in corso...",
    },
    common: {
      close: "Chiudi", cancel: "Annulla", loading: "Caricamento...",
      city: "Città", filter_city: "Filtra per città",
    },
  },
  en: {
    nav: { showcase: "Showcase", directory: "Properties", network: "Network", pricing: "Pricing", login: "Sign in", signup: "Register property", dashboard: "Dashboard", logout: "Sign out", book: "Book", host_area: "I run a property" },
    landing: {
      eyebrow: "Platform for hospitality structures",
      title1: "Italian hospitality,",
      title2: "networked.",
      subtitle: "Promote your property, sync OTAs, swap rooms with trusted partners. A digital home for B&Bs, farmhouses and hotels.",
      cta_primary: "Start free",
      cta_secondary: "Browse showcases",
      f1_title: "Bilingual showcase",
      f1_body: "A public IT/EN page that tells your story. Photos, rooms, direct booking via Stripe.",
      f2_title: "Structure network",
      f2_body: "Overbooked? Route the guest to a partner. National marketplace + local closed groups.",
      f3_title: "Group requests",
      f3_body: "Post a large group request — nearby structures respond. Centralized breakfast included.",
      f4_title: "Unified calendar",
      f4_body: "Direct bookings, network rooms, OTAs synced via iCal (coming). Zero overbooking.",
      showcase_title: "Featured properties",
      showcase_sub: "Some of the houses telling their story on HospitalityHub.",
      how_title: "How it works",
      how_1: "Register your property",
      how_1b: "Sign up in 60 seconds. Auto-verified for MVP.",
      how_2: "Set up your IT/EN showcase",
      how_2b: "Bilingual copy, photos, services, rooms. Publish when you're ready.",
      how_3: "Join the network",
      how_3b: "Offer last-minute rooms, answer group requests, get paid.",
      final_title: "The digital home of Italian hospitality",
      final_body: "One platform to manage showcase, network and bookings.",
    },
    auth: {
      login: "Sign in", register: "Register your property",
      email: "Email", password: "Password", structure: "Property name",
      cin_label: "CIN code",
      cin_help: "Italian National Identification Code (MITUR) — mandatory by law (DL 145/2023). National format: IT + 15 chars (17 total). Some regions like Sicily may use longer formats (up to 22 chars). Request it at bdsr.ministeroturismo.gov.it",
      submit_login: "Enter", submit_register: "Create account",
      switch_to_register: "No account? Register your property",
      switch_to_login: "Already have an account? Sign in",
      forgot: "Forgot password?",
      demo_hint: "Demo: demo@hospitalityhub.it / demo1234",
    },
    dash: {
      welcome: "Welcome,", overview: "Overview", property: "Property",
      rooms: "Rooms", bookings: "Bookings", marketplace: "Network",
      groups: "Group requests", reviews: "Reviews",
      ical: "OTA Sync", swaps: "Swaps", breakfast: "Breakfast",
      total_bookings: "Total bookings", revenue: "Revenue",
      open_offers: "Open offers", published: "Published",
      not_published: "Not published",
      publish: "Publish showcase", unpublish: "Unpublish",
      view_showcase: "View public showcase",
      copy_link: "Copy link", copied: "Copied!",
      save: "Save changes", saved: "Saved",
      name: "Name", city: "City", region: "Region", address: "Address",
      phone: "Phone", desc_it: "Description (IT)", desc_en: "Description (EN)",
      amenities: "Amenities (comma separated)",
      hero_image: "Hero image",
      photos: "Photo gallery",
      property_type: "Property type",
      add_room: "Add room", room_name: "Room name",
      price_night: "Price/night (€)", capacity: "Capacity",
      photo_url: "Photo URL",
      publish_offer: "Post to network",
      no_bookings: "No bookings yet",
      no_rooms: "No rooms yet. Add one to get started.",
      offer_from: "From", offer_to: "To",
      post_group_req: "Post group request",
      title: "Title", guests: "Guests", budget: "Budget/night (€)",
      notes_it: "Notes (IT)", notes_en: "Notes (EN)",
      respond: "Respond", rooms_offered: "Rooms offered",
      message: "Message", send: "Send response",
      responses: "responses",
      total: "Total",
      night: "night", nights: "nights",
      upload_photo: "Upload photo",
      uploading: "Uploading...",
      drop_here: "Drop or click to upload",
      remove: "Remove",
      ical_title: "OTA Sync via iCal",
      ical_sub: "Import availability and bookings from Booking, Airbnb, Expedia, Vrbo.",
      ical_url: "iCal URL",
      ical_source: "Platform", ical_import: "Import",
      ical_last_sync: "Last sync", ical_events: "Imported events",
      calendar_unified: "Unified calendar",
      swap_forward: "Forward to partner",
      swap_title: "Room swap",
      partner_property: "Partner property",
      partner_room: "Partner room",
      commission_10: "10% commission will be applied",
      swap_notes: "Notes to the partner",
      swap_send: "Propose swap",
      no_swaps: "No swaps yet",
      breakfast_title: "Centralized breakfast",
      breakfast_sub: "Offer or book breakfast covers for guests in the network.",
      add_breakfast_slot: "New breakfast slot",
      slot_date: "Date", slot_time: "Time",
      slot_max: "Max covers",
      slot_price: "Price/cover (€)",
      book_covers: "Book covers",
      covers: "covers",
      book_slot: "Book", available: "available",
      your_breakfast_bookings: "Your breakfast bookings",
      role: "Role", date: "Date", amount: "Amount",
      source: "Source", event_title: "Title", start: "Start", end: "End",
      no_events: "No events yet — import an iCal or receive a booking.",
      welcome_back: "Welcome back",
      toast_uploaded: "Uploaded", toast_upload_failed: "Upload failed",
      toast_error: "Error", toast_swap_sent: "Swap proposed · guest notified",
      toast_slot_added: "Slot added", toast_slot_booked: "Booked",
      toast_offer_posted: "Offer posted", toast_gr_posted: "Request posted",
      toast_response_sent: "Response sent", toast_imported: "Imported {n} events",
      select_room: "Select room", select_partner: "Select partner",
      select_booking: "Select booking", no_paid_bookings: "No paid bookings",
      per_cover: "per cover",
      outgoing: "outgoing", incoming: "incoming",
      from_label: "From:", to_label: "To:",
      commission_10pct: "Commission (10%)",
      analytics: "Analytics",
      revenue_monthly: "Monthly revenue",
      direct_bookings: "Direct bookings",
      swap_commissions: "Swap commissions",
      breakfast_income: "Breakfast income",
      no_analytics: "No data yet — start receiving bookings.",
      stripe_connect: "Automatic payouts",
      connect_start: "Enable Stripe Connect",
      connect_continue: "Complete onboarding",
      connect_done: "Payouts active",
      connect_pending: "Onboarding in progress",
      connect_hint: "Direct bookings arrive automatically net of the HospitalityHub commission (8% Base · 6% Pro · 5% Enterprise). Stripe payment processing fees are borne by the connected account.",
      accept_split: "Accept & split",
      select_partners: "Select partners",
      allocated_rooms: "Allocated rooms",
      allocation_confirmed: "Allocation confirmed",
      push_title: "Browser notifications",
      push_hint: "Get an alert on your device even when the tab is closed.",
      push_enable: "Enable", push_disable: "Disable",
      push_on: "On", push_off: "Off", push_denied: "Blocked by browser",
      instagram: "Instagram",
      ig_handle: "Instagram handle (@)",
      ig_posts: "Recent posts",
      ig_add: "Add post",
      ig_image: "Image URL",
      ig_caption: "Caption",
      ig_link: "Post link",
      verification: "Verification",
      verify_title: "Property verification",
      verify_hint: "Verified structures show a ✓ badge on the marketplace and vetrina.",
      verified: "Verified",
      pending_verify: "Pending",
      not_verified: "Not verified",
      submit_verify: "Request verification",
      vat_number: "VAT number (11 digits)",
      business_name: "Business name",
      municipality: "Municipality",
      declaration: "I declare that this information is correct",
      admin: "Administration",
      admin_pending: "Pending requests",
      approve: "Approve", reject: "Reject",
      admin_note: "Internal note",
      ai_copy: "Generate with AI",
      ai_copy_title: "Generate vetrina with AI",
      ai_copy_hint: "Enter a few keywords — AI will craft IT/EN copy + amenities.",
      ai_keywords: "Keywords (comma separated)",
      ai_tone: "Tone",
      ai_generate: "Generate",
      ai_apply: "Apply to vetrina",
      promo_code: "Promo code",
      promo_apply: "Apply",
      promo_valid: "Code valid",
      promo_saved: "You save",
      trade_nav: "Trade B2B",
      trade_title: "B2B for tour operators and agencies",
      trade_sub: "Buy room blocks directly from Italian structures at wholesale rates.",
      trade_offers: "Trade offers",
      trade_login: "Trade sign in", trade_register: "Register agency",
      trade_company: "Agency / tour operator name",
      trade_vat: "VAT number",
      trade_country: "Country",
      trade_publish: "Publish trade offer",
      trade_new_offer: "New trade offer",
      trade_rooms_available: "Rooms available",
      trade_price_per_night: "Price/room/night (€)",
      trade_min_nights: "Min nights",
      trade_buy: "Buy now",
      trade_orders_mine: "My orders",
      trade_sold: "sold",
      trade_tab: "Trade",
      channels_tab: "OTA Channels",
    },
    vetrina: {
      book: "Book", from: "from", per_night: "/ night",
      rooms: "Rooms", reviews: "Reviews", contact: "Contact",
      leave_review: "Leave a review",
      guest_name: "Your name", rating: "Rating",
      comment: "Your comment", submit: "Submit review",
      services: "Services", check_in: "Check-in", check_out: "Check-out",
      guest_email: "Your email", confirm_book: "Confirm & pay",
      total_price: "Total", processing: "Processing...",
      book_this_room: "Book this room",
      promo_code: "Promo code", promo_apply: "Apply",
      promo_valid: "Code valid", promo_saved: "You save",
    },
    guest: {
      my_bookings: "My bookings",
      my_maps: "My maps",
      travellers_area: "Traveller area",
      have_account: "Already have an account?",
      login: "Log in",
      signup: "Sign up",
    },
    pay: {
      success: "Booking confirmed",
      success_body: "You'll receive a confirmation email. Thank you!",
      cancel: "Payment canceled",
      cancel_body: "No charge was made.",
      back_home: "Back home",
      checking: "Checking payment status...",
    },
    common: {
      close: "Close", cancel: "Cancel", loading: "Loading...",
      city: "City", filter_city: "Filter by city",
    },
  },
};

const LangContext = createContext({ lang: "it", setLang: () => {}, t: (k) => k });

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("hh_lang") || "it");
  useEffect(() => { localStorage.setItem("hh_lang", lang); document.documentElement.lang = lang; }, [lang]);
  const t = (key) => {
    const parts = key.split(".");
    let cur = dict[lang];
    for (const p of parts) { if (cur && p in cur) cur = cur[p]; else return key; }
    return cur;
  };
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
